import { render, staticRenderFns } from "./delivery-options.vue?vue&type=template&id=57e1af20&"
import script from "./delivery-options.vue?vue&type=script&lang=js&"
export * from "./delivery-options.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports